module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	methods: {
		/**
		 * this function will be called after the response of a submit request has returned.
		 *
		 * @param   response        {} - server response
		 */
		onSubmit: function(response){
			this.refresh();
		}
	}
}